import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Card, CardActionArea, CardContent, Typography, CardMedia, Stack } from "@mui/material";
import StarIcon from '../../images/star_rating.png';
import { apiBaseUrl } from '../../utils/Api/Api';
import ProductPhotoPlaceholder from '../../images/placeholder_product_image.png';
import { currency } from './Currency';

const Content = styled(CardContent)({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '8px',
});

const ProviderCard = ({ provider, onCardClick, showProducts }) => {
  return (
    <Box my={1}>
      <Card>
        <CardActionArea onClick={onCardClick}>
          <Content>
            <Box>
              <Avatar sx={{ border: '1px solid lightgray' }} src={provider.business_logo && `${apiBaseUrl}${provider.business_logo}`} />
            </Box>
            <Box flexGrow={1} ml={2} textAlign="left">
              <Typography variant="body1"><b>{provider.name}</b></Typography>
              <Typography fontSize={14} color="gray">
                <img style={{ width: '16px', height: '16px' }} src={StarIcon} />
                <img style={{ width: '16px', height: '16px' }} src={StarIcon} />
                <img style={{ width: '16px', height: '16px' }} src={StarIcon} />
                <img style={{ width: '16px', height: '16px' }} src={StarIcon} />
                <img style={{ width: '16px', height: '16px' }} src={StarIcon} />
                {provider.rating || '5,0'}
              </Typography>
              <Typography fontSize={14} color="gray">
                <small>Entrega em até 24h &#9679; R$10,00</small>
              </Typography>
            </Box>
          </Content>
          {showProducts && (
            <CardContent sx={{padding: 1}}>
              <Stack
                direction="row"
                spacing={1}
                sx={{
                  overflowX: 'auto', // Scroll horizontal
                  overflowY: 'hidden', // Esconde overflow vertical
                  whiteSpace: 'nowrap', // Mantém itens em linha
                  scrollbarWidth: 'thin', // Estiliza scrollbar (Firefox)
                  '&::-webkit-scrollbar': { height: '8px' }, // Estiliza scrollbar (Chrome/Safari)
                  '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)' },
                }}
              >
                {provider.products &&
                  provider.products.map((product) => (
                    <Card
                      key={product.id}
                      variant='outlined'
                      sx={{ 
                        width: 160, 
                        margin: 1,
                        flexShrink: 0, // Impede que o card encolha
                        display: 'inline-block', // Garante alinhamento horizontal
                      }}
                      onClick={(e) => {
                        // e.stopPropagation();
                        // navigate('/product/' + product.id);
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="100"
                        image={product.item_photo ? `${apiBaseUrl}${product.item_photo}` : ProductPhotoPlaceholder}
                        alt={product.title}
                      />
                      <CardContent sx={{padding: 1}}>
                        <Typography variant="body2" sx={{textAlign: 'left'}}>{product.title}</Typography>
                        {/* parei aqui: Adicionr preço? */}
                        <Typography variant="body2" mt={1} sx={{ fontWeight: 'bold' , textAlign: 'left'}}>{currency(product.price)}</Typography>
                      </CardContent>
                    </Card>
                  ))}
              </Stack>
            </CardContent>
          )}
        </CardActionArea>
      </Card>
    </Box>
  );
};

export default ProviderCard;

